import { Repository } from "./adapters/repository";

import * as assignTag from "./useCases/assignTag";
import * as removeTag from "./useCases/removeTag";
import * as retrieveProjectsElementsTags from "./useCases/retrieveProjectsElementsTags";
import * as retrieveProjectsTags from "./useCases/retrieveProjectsTags";
import * as retrieveResourcesTags from "./useCases/retrieveResourcesTags";
import * as retrieveProjectResourcesTags from "./useCases/retrieveProjectResourcesTags";

enum UseCases {
  assignTag = "assignTag",
  removeTag = "removeTag",
  retrieveProjectsElementsTags = "retrieveProjectsElementsTags",
  retrieveProjectsTags = "retrieveProjectsTags",
  retrieveResourcesTags = "retrieveResourcesTags",
  retrieveProjectResourcesTags = "retrieveProjectResourcesTags",
}

interface Core {
  [UseCases.assignTag]: assignTag.Interactor;
  [UseCases.removeTag]: removeTag.Interactor;
  [UseCases.retrieveProjectsElementsTags]: retrieveProjectsElementsTags.Interactor;
  [UseCases.retrieveProjectsTags]: retrieveProjectsTags.Interactor;
  [UseCases.retrieveResourcesTags]: retrieveResourcesTags.Interactor;
  [UseCases.retrieveProjectResourcesTags]: retrieveProjectResourcesTags.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = { repository: Repository };

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrieveProjectsElementsTags]:
      retrieveProjectsElementsTags.createInteractor(dependencies.repository),
    [UseCases.retrieveResourcesTags]: retrieveResourcesTags.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveProjectsTags]: retrieveProjectsTags.createInteractor(
      dependencies.repository,
    ),
    [UseCases.retrieveProjectResourcesTags]:
      retrieveProjectResourcesTags.createInteractor(dependencies.repository),
    [UseCases.assignTag]: assignTag.createInteractor(dependencies.repository),
    [UseCases.removeTag]: removeTag.createInteractor(dependencies.repository),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
